import { render, staticRenderFns } from "./automation-level-tabs.vue?vue&type=template&id=23141b80"
import script from "./automation-level-tabs.vue?vue&type=script&lang=js"
export * from "./automation-level-tabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports